// tslint:disable: cyclomatic-complexity
import Styled, { css } from 'styled-components';

import { media } from '../../../../lib/StyledComponents/StyledComponents';
import { cssDeclaration } from '../../Utils';

import { VALID_HEADER_LINKS } from './HeaderLink';

interface IHeaderLinkProps {
  hideOnMobile: boolean;
  hideOnDesktop: boolean;
  variant?: VALID_HEADER_LINKS;
  current?: boolean;
}

export const StyledHeaderLink = Styled.a<IHeaderLinkProps>`
  ${({ theme: { themeTwo }, hideOnMobile, hideOnDesktop, variant, current }) => {
    const { layout: { header }} = themeTwo;
    const link = variant === 'default' ? header.link : header.dropdown.link;
    const { state: { hover, focus }} = link;

    return css`
      text-decoration: none;
      transition: color 100ms ease-out;
      line-height: ${link.font.lineHeight};
      /* text-align */ ${cssDeclaration(themeTwo, 'text-align', link.font.align)};
      /* font-weight */ ${cssDeclaration(themeTwo, 'font-weight', link.font.weight)};
      /* font-size */ ${cssDeclaration(themeTwo, 'font-size', link.font.size)};
      /* padding */ ${cssDeclaration(themeTwo, 'padding', link.padding)};
      /* color */ ${cssDeclaration(themeTwo, 'color', link.font.color)};
      /* background-color */ ${cssDeclaration(themeTwo, 'background-color', link.backgroundColor)};
      /* border */ ${cssDeclaration(themeTwo, 'border', link.border)};

      ${variant === 'dropdown' && css`
        display: inline-block;
        width: 100%;
        position: relative;

        ${link.border && focus && css`
          &:focus {
            outline: none;
            /* border */ ${focus.border && cssDeclaration(themeTwo, 'border', focus.border)};
          }
        `}
      `}

      ${hideOnMobile && css`
        display: none;

        ${media.small`
          display: flex;
        `}
      `}

      ${hideOnDesktop && css`
        ${media.small`
          display: none;
        `}
      `}

      ${current && link.state.current && css`
        /* padding */ ${link.state.current.padding &&
          cssDeclaration(themeTwo, 'padding', link.state.current.padding)};
        /* margin */ ${link.state.current.margin &&
          cssDeclaration(themeTwo, 'margin', link.state.current.margin)};
        /* background-color */ ${link.state.current.backgroundColor &&
          cssDeclaration(themeTwo, 'background-color', link.state.current.backgroundColor)};

        ${link.state.current.font && css`
          /* font-weight */ ${link.state.current.font.weight && cssDeclaration(themeTwo, 'font-weight', link.state.current.font.weight)};
          /* font-size */ ${link.state.current.font.size && cssDeclaration(themeTwo, 'font-size', link.state.current.font.size)};
          /* color */ ${link.state.current.font.color && cssDeclaration(themeTwo, 'color', link.state.current.font.color)};
          /* font-family */ ${link.state.current.font.family && cssDeclaration(themeTwo, 'font-family', link.state.current.font.family)};
        `}
      `}

      &:hover {
        /* font-weight */ ${hover.font && hover.font.weight && cssDeclaration(themeTwo, 'font-weight', hover.font.weight)};
        /* font-size */ ${hover.font && hover.font.size && cssDeclaration(themeTwo, 'font-size', hover.font.size)};
        /* font-family */ ${hover.font && hover.font.family && cssDeclaration(themeTwo, 'font-family', hover.font.family)};
        /* padding */ ${hover.padding && cssDeclaration(themeTwo, 'padding', hover.padding)};
        /* margin */ ${hover.margin && cssDeclaration(themeTwo, 'margin', hover.margin)};
        /* color */ ${hover.font && hover.font.color && cssDeclaration(themeTwo, 'color', hover.font.color)};
        /* background-color */ ${hover.backgroundColor && cssDeclaration(themeTwo, 'background-color', hover.backgroundColor)};
      }

      &:focus {
        /* font-weight */ ${focus.font && focus.font.weight && cssDeclaration(themeTwo, 'font-weight', focus.font.weight)};
        /* font-size */ ${focus.font && focus.font.size && cssDeclaration(themeTwo, 'font-size', focus.font.size)};
        /* font-family */ ${focus.font && focus.font.family && cssDeclaration(themeTwo, 'font-family', focus.font.family)};
        /* padding */ ${focus.padding && cssDeclaration(themeTwo, 'padding', focus.padding)};
        /* margin */ ${focus.margin && cssDeclaration(themeTwo, 'margin', focus.margin)};
        /* color */ ${focus.font && focus.font.color && cssDeclaration(themeTwo, 'color', focus.font.color)};
        /* background-color */ ${focus.backgroundColor && cssDeclaration(themeTwo, 'background-color', focus.backgroundColor)};
      }
    `;
  }}
`;
